import { useProfile } from '@modules/profile/loader';
import { Profile } from '@modules/profile/model';
import * as P from 'fp-ts/Predicate';

export function useProfilePredicate(predicate: P.Predicate<Profile>) {
  return predicate(useProfile());
}
